import { render, staticRenderFns } from "./AdminAreaInfo.vue?vue&type=template&id=03579d01&scoped=true"
import script from "./AdminAreaInfo.vue?vue&type=script&lang=js"
export * from "./AdminAreaInfo.vue?vue&type=script&lang=js"
import style0 from "./AdminAreaInfo.vue?vue&type=style&index=0&id=03579d01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03579d01",
  null
  
)

export default component.exports